import { McDbText, McGePoint3d } from "mxcad";

class rlText {
  constructor() {
    this.classTypeName = "rlText";
    this.m_groupName = "rlTextGroup";
    this.position = null;
    this.McDbText = new McDbText();
    this.McDbTextId = null;
    this.Text = "";
    this.lineObjId = null;
    this.fontSize = null;
    this.dAngle = 0;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  // 生成节点
  setPoints(points) {
    this.points = [new THREE.Vector3(...points)];
  }

  // 移动
  transformBy(_mat) {
    this.position.add(_mat);
    this.setNeedUpdateDisplay(true);
  }

  // 绘制
  draw() {
    if (this.Text && this.Text != "") {
      this.fontSize = this.calculateFontSize(this.Text);
      this.McDbText.textString = this.Text;
      this.McDbText.height = this.fontSize;
      this.McDbText.verticalMode = 2;
      this.McDbText.horizontalMode = 1;
      this.McDbText.position = this.McDbText.alignmentPoint = new McGePoint3d(
        this.position.x,
        this.position.y
      );
      this.McDbText.rotation = this.dAngle;

      this.McDbTextId = rlAppObj.mxcadObject.drawEntity(this.McDbText);
    }
  }

  // 字体大小自适应
  calculateFontSize(Text) {
    let count = 0;
    for (let i = 0; i < Text.length; i++) {
      if (Text.charCodeAt(i) > 127 || Text.charCodeAt(i) == 94) {
        count += 2;
      } else {
        count++;
      }
    }

    // 标准400大小
    if (count > 3) {
      return 400 / (count / 3);
    } else {
      return 400;
    }
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj["points"] = [];
    this.points.forEach((val) => {
      obj["points"].push(val.clone());
    });
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    //  // 这里是自定义对象自己的属性
    let ary = obj["points"];
    this.points = [];
    ary.forEach((val) => {
      this.points.push(val.clone());
    });
    return true;
  }
}

export { rlText };
